<template>
  <div class="guide-ios-container">
    <h1>元邦導覽員 iOS</h1>
  </div>
</template>

<script>
export default {
  name: 'GuideIOS',
  mounted() {
    // 页面加载后直接跳转到App Store
    window.location.href = 'https://apps.apple.com/tw/app/%E5%85%83%E9%82%A6%E5%B0%8E%E8%A6%BD%E5%93%A1/id6752892219'
  }
}
</script>

<style scoped>
.guide-ios-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #007aff;
  margin-bottom: 20px;
}
</style>
